import FJActionConstant from "../../constant/FJActionConstant";
import FJCanvasStore from "../../store/FJCanvasStore";
import FJUtil from "../../util/FJUtil";
import {FJExportVideoAction, FJPaymentAction} from "./FJRoot.action";

let FJUserAction = (function () {

  return {

    /**
     * @description 设置作者
     * @param videoEditor
     * @param options
     */
    changeEditorNameAction: function (videoEditor, options = {}) {
      return (dispatch) => {
        const {done, isSubmit} = options;
        if (isSubmit) {
          if (videoEditor !== FJCanvasStore.executeSync(FJCanvasStore.command.GET_VIDEO_EDITOR)) {
            FJCanvasStore.executeSync(FJCanvasStore.command.SET_EDITOR, videoEditor);
            dispatch(this.updateEditorNameAction(videoEditor));
            dispatch(FJExportVideoAction.updateIntroDataCoreAction());
            done();
          }
        } else {
          dispatch(this.updateEditorNameAction(videoEditor));
        }
      }
    },

    /**
     * @description 更新作者
     * @param videoEditor
     * @return {{videoEditor, type: string}}
     */
    updateEditorNameAction: function (videoEditor) {
      return {
        type: FJActionConstant.UPDATE_EDITOR_NAME,
        videoEditor,
      }
    },

    setLoginStatusAction: function (isLogin) {
      return (dispatch) => {
        dispatch(this.updateLoginStatusAction(isLogin));
        dispatch(FJPaymentAction.checkLevelAction());
      };
    },

    updateLoginStatusAction: function (isLogin) {
      return {
        type: FJActionConstant.UPDATE_LOGIN_STATUS,
        isLogin,
      }
    },

    /**
     * @description 修改工程名
     * @param name
     * @param options
     * @param options.done
     * @param options.isSubmit
     * @return {(function(*))|*}
     */
    changeExportNameAction: function (name, options = {}) {
      return (dispatch) => {
        const {done, isSubmit} = options;
        dispatch(this.updateExportNameAction(name));
        if (isSubmit) {
          let curProjectName= FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_NAME);
          if (name !== curProjectName) {
            if (FJUtil.testStr(name)) {
              dispatch(this.updateExportNameAction(curProjectName));
              dispatch(FJExportVideoAction.updateIntroDataCoreAction());
            } else if (name.trim() === '') {
              dispatch(this.updateExportNameAction(name));
              dispatch(FJExportVideoAction.updateIntroDataCoreAction());
              done();
            } else {
              dispatch(this.updateProjectNameAction(name));
              dispatch(this.editProjectNameInNetworkAction(done));
              dispatch(FJExportVideoAction.updateIntroDataCoreAction());
            }
          }
        }
      };
    },

    /**
     * @description 更新reduce的工程名字
     * @param videoName
     * @returns {{data: *, type: string}}
     */
    updateExportNameAction: function (videoName) {
      return {
        type: FJActionConstant.UPDATE_EXPORT_VIDEO_NAME,
        videoName: videoName
      };
    },

    /**
     * @description 更新reduce的工程名字
     * @param name
     * @returns {{data: *, type: string}}
     */
    updateProjectNameAction: function (name) {
      return {
        type: FJActionConstant.UPDATE_PROJECT_NAME,
        data: name
      };
    },

    /**
     * @description 更新reduce的工程名字未canvas的原工程名
     * @param shouldUpdateExportName
     */
    updateProjectOldNameAction: function (shouldUpdateExportName = true) {
      return (dispatch) => {
        let name = FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_NAME);
        dispatch(this.updateProjectNameAction(name));
        if (shouldUpdateExportName) {
          dispatch(this.updateExportNameAction(name));
        }
      }
    },

    /**
     * @description 更新工程名（network）
     */
    editProjectNameInNetworkAction: function (done = () => {
    }) {
      return async (dispatch, getState) => {
        const user = getState().user;
        if (user.projectName === FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_NAME)) {
          done();
          return
        }

        let updateProjectName = async () => {
          try {
            await FJCanvasStore.execute(FJCanvasStore.command.CHANGE_PROJECT_NAME, user.projectName);
            dispatch(this.updateExportNameAction(user.projectName))
          } catch (e) {
            let name = FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_NAME);
            dispatch(this.updateProjectNameAction(name));
            dispatch(this.updateExportNameAction(name))
          }
          done();
        };

        let updateProjectOldName = () => {
          let name = FJCanvasStore.executeSync(FJCanvasStore.command.GET_PROJECT_NAME);
          dispatch(this.updateProjectNameAction(name));
          dispatch(this.updateExportNameAction(name))
          done();
        };

        if (!FJUtil.isLogin() || FJUtil.isAnonymousProject()) {
          updateProjectOldName();
        } else {
          updateProjectName();
        }

      }
    }
  }
})();

export default FJUserAction;
